/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import useCustomizableContext from "~/CustomizableToolPage/useCustomizableContext";
import { addImage } from "~/CustomizableToolPage/fabric/utils";

const ImageList = () => {
  const {
    userAssets,
    fabric: { canvas },
  } = useCustomizableContext();

  const handleClick = (path: string) => {
    const asset = userAssets[path];
    if (!asset) return;
    addImage(canvas, asset.path, asset.id);
  };

  const startDrag = (event: React.DragEvent<HTMLDivElement>, path: string) => {
    event.dataTransfer.setData("text/plain", path);
  };

  return (
    <div id="image-list">
      {Object.values(userAssets).map((item) => (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
          key={item.id}
          className="customize__past"
          onClick={() => handleClick(item.path)}
          draggable
          onDragStart={(e) => startDrag(e, item.path)}
        >
          <div
            className="customize__past-inner"
            style={{ backgroundImage: `url(${item.thumbnailPath})` }}
          />
        </div>
      ))}
    </div>
  );
};

export default ImageList;
